
namespace TabAurous.Sales {

    @Serenity.Decorators.registerClass()
    export class ApprovalOutReturnItemsGrid extends Serenity.EntityGrid<ApprovalOutReturnItemsRow, any> {
        protected getColumnsKey() { return 'Sales.ApprovalOutReturnItems'; }
        protected getDialogType() { return ApprovalOutReturnItemsDialog; }
        protected getIdProperty() { return ApprovalOutReturnItemsRow.idProperty; }
        protected getInsertPermission() { return ApprovalOutReturnItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return ApprovalOutReturnItemsRow.localTextPrefix; }
        protected getService() { return ApprovalOutReturnItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
       
        }

        protected getSlickOptions() {
            let opt = super.getSlickOptions();
            opt.editable = true;
            opt.autoEdit = true;
            //opt.forceFitColumns = true;
            return opt;
        }
        
    }
}